$(document).on('click', '.attachment.fav-article-btn', function (e) {
    e.preventDefault()
    window.location.href = '/users/sign_in';
})

$(document).on('click', '.attachment.fav-room-btn', function (e) {
    e.preventDefault()
    window.location.href = '/users/sign_in';
})